import {
    CategoriaAtendimentoPorCaso,
    ICategoriaAtendimento,
    IModuloCategoriaAtendimento,
} from "../../../Interfaces/Geral/GestaoDeCadastro/CategoriaAtendimento/CategoriaAtendimentoInterface";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function GetCategoriaAtendimentoService(
    idCategoriaAtendimento: number
) {
    return Service(
        Axios.get<ICategoriaAtendimento>(
            `/home/categoriaatendimento/getcategoriaatendimento?idCategoriaAtendimento=${idCategoriaAtendimento}`
        )
    );
}

export async function ListarCategoriaAtendimentoPaiService(
    ID_TIPO_CASO: number
) {
    return Service(
        Axios.get<Array<ICategoriaAtendimento>>(
            `/home/categoriaatendimento/listarcategoriaatendimentopai?ID_TIPO_CASO=${ID_TIPO_CASO}`
        )
    );
}

export async function ListarCategoriaAtendimentoService(ID_TIPO_CASO: number) {
    return Service(
        Axios.get<Array<ICategoriaAtendimento>>(
            `/home/categoriaatendimento/listarcategoriaatendimentogeral?ID_TIPO_CASO=${ID_TIPO_CASO}`
        )
    );
}

export async function ListarCategoriaAtendimentoArvorePorTipoCasoService(
    ID_TIPO_CASO: number
) {
    return Service(
        Axios.get<Array<ICategoriaAtendimento>>(
            `/home/categoriaatendimento/listarcategoriaatendimentoarvoretipocaso?ID_TIPO_CASO=${ID_TIPO_CASO}`
        )
    );
}

export async function ListarCategoriaAtendimentoArvoreService(
    idTipoCaso: number
) {
    return Service(
        Axios.get<Array<ICategoriaAtendimento>>(
            `/home/categoriaatendimento/listarcategoriaatendimentoarvore?ID_TIPO_CASO=${idTipoCaso}`
        )
    );
}

export async function ListarCategoriaAtendimentosService() {
    return Service(
        Axios.get<Array<ICategoriaAtendimento>>(
            `/home/categoriaatendimento/listarcategoriasatendimento`
        )
    );
}

export async function ListarCategoriaAtendimentoFilhosService(
    idCategoriaAtendimentoPai: number
) {
    return Service(
        Axios.get<Array<ICategoriaAtendimento>>(
            `/home/categoriaatendimento/listarcategoriaatendimentofilho?ID_TIPO_CASO=${idCategoriaAtendimentoPai}`
        )
    );
}

export async function AtualizarCategoriaAtendimentoService(
    requestBody: ICategoriaAtendimento
) {
    return Service(
        Axios.put(
            `/home/categoriaatendimento/atualizarcategoriaatendimento`,
            requestBody
        )
    );
}

export async function DeletarCategoriaAtendimentoService(
    ID_CATEGORIA_ATENDIMENTO: number
) {
    return Service(
        Axios.delete(
            `/home/categoriaatendimento/DeletarCategoriaAtendimento?ID_CATEGORIA_ATENDIMENTO=${ID_CATEGORIA_ATENDIMENTO}`
        )
    );
}

export async function InserirCategoriaAtendimentoService(
    requestBody: ICategoriaAtendimento
) {
    return Service(
        Axios.post(
            `/home/categoriaatendimento/inserircategoriaatendimento`,
            requestBody
        )
    );
}

export async function ListarModulosVinculadosPorCategoriaService(
    ID_CATEGORIA_ATENDIMENTO: number
) {
    return Service(
        Axios.get<Array<IModuloCategoriaAtendimento>>(
            `/home/categoriaatendimento/listartiposcasovinculadosporcategoriaatendimento?ID_CATEGORIA_ATENDIMENTO=${ID_CATEGORIA_ATENDIMENTO}`
        )
    );
}

export async function VincularModuloCategoriaAtendimentoService(
    requestBody: IModuloCategoriaAtendimento
) {
    return Service(
        Axios.post(
            `/home/categoriaatendimento/inserircategoriaatendimentotipocaso`,
            requestBody
        )
    );
}

export async function DesvincularModuloCategoriaAtendimentoService(
    ID_CATEGORIA_ATENDIMENTO_TIPO_CASO: number
) {
    return Service(
        Axios.delete(
            `/home/categoriaatendimento/deletarcategoriaatendimentotipocaso?ID_CATEGORIA_ATENDIMENTO_TIPO_CASO=${ID_CATEGORIA_ATENDIMENTO_TIPO_CASO}`
        )
    );
}

export async function ListarCategoriasDeAtendimentoPorCasoService(
    idCaso: number
) {
    return Service(
        Axios.get<Array<CategoriaAtendimentoPorCaso>>(
            `/home/categoriacasoassistenciatec/listacategoriasdeatendimentoporcaso?idCaso=${idCaso}`
        )
    );
}
